'use strict';

/*
** get markers coordinates from polygons
*/

const getMarkers = (polygons) => {
  if (polygons.length > 0) {

    return polygons.map(({ center, content }, index) => {
      return { 'location': center, content }
    });
  }
};

export default getMarkers;